module.exports = __webpack_public_path__ + "img/summit-1.97823899.jpg";